<div [class.grid-4-col]="maxFolderColumns==4" [class.grid-3-col]="maxFolderColumns==3" [class.grid-2-col]="maxFolderColumns==2" [class.grid-1-col]="maxFolderColumns==1">
@for (folder of folders; track folder){
  <app-folder [uploads]="uploads" [folder]="folder" [type]="type"></app-folder>
}
</div>
